import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const slideKeys = [
  {
    src: 'https://public.readdy.ai/ai/img_res/edited_2645ec2179e48d98104213c1ddd0ca3c_f6931f7d.jpg',
    alt: 'Youngbin Hotel Exterior',
    labelKey: 'hero_slide5_label',
    objectPosition: 'object-center',
    overlayLight: true,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/f1a4733f-f142-44b4-9a4b-319ee3c3a442/cbd75e65-4278-44f3-ad8a-40c0a407155d_f9a652c3b1f441d2b096c67fc4c33bad.png?v=6576a13c0468d12de2603327ddc56e1f',
    alt: 'Room',
    labelKey: 'hero_slide2_label',
    objectPosition: 'object-center',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/40bb85edd389469cbcd1507f2a2259b4.jpg',
    alt: 'Dongdaemun DDP',
    labelKey: 'hero_slide4_label',
  },
];

const Hero = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slideKeys.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[100vh] min-h-[600px] overflow-hidden">
      {slideKeys.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.src}
            alt={slide.alt}
            className={`w-full h-full object-cover ${slide.objectPosition ?? 'object-top'}`}
          />
          {slide.overlayLight && (
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/50" />
          )}
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <p className="text-amber-300 text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase mb-2 md:mb-4 font-light">
          {t('hero_welcome')}
        </p>
        <h1 className="text-white text-3xl md:text-6xl font-bold leading-tight mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
          {t('hero_title')}
        </h1>
        <p className="text-white/80 text-base md:text-xl mb-1 md:mb-2 font-light">
          {t('hero_subtitle')}
        </p>
        <p className="text-amber-300/90 text-xs md:text-base mb-6 md:mb-8 tracking-widest font-light transition-all duration-700">
          {t(slideKeys[current].labelKey)}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
          <a
            href="#reservation"
            className="px-7 md:px-8 py-2.5 md:py-3 bg-amber-700 text-white rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero_cta_reserve')}
          </a>
          <a
            href="/rooms"
            className="px-7 md:px-8 py-2.5 md:py-3 border border-white text-white rounded-full text-sm font-medium hover:bg-white hover:text-amber-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero_cta_rooms')}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slideKeys.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`h-2 rounded-full transition-all cursor-pointer ${
              idx === current ? 'bg-amber-400 w-6' : 'bg-white/50 w-2'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
